import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsHelpMessages = defineMessages("settings-help", en);
